import React, { createContext, useState, useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import EventListener from './EventListener';
import { IdleTimerProvider, useIdleTimer } from 'react-idle-timer'; // ADICIONE ESTA LINHA

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('accessToken') || null);
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  const refreshTimeout = useRef(null);



  const checkTokenAndRedirect = async () => {
    try {
      const isValid = await isAuthenticated();
      if (!isValid) {
        logout();
        navigate('/'); // Redireciona para a página de login
      }
    } catch (error) {
      console.error('Erro ao verificar o token:', error);
      logout();
      navigate('/'); // Redireciona para a página de login
    }
  };

  const login = async (email, password) => {

    //console.log('REACT_APP_AUTHAPI:', process.env.REACT_APP_AUTHAPI);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_AUTHAPI}/login`,
        { email, password },
        {          withCredentials: true,
          credentials: 'include', } // <-- Adicione isso aqui!
      );
      //console.log(response.data.message);
      // Agora não precisa mais salvar token no localStorage!
    } catch (error) {
      throw new Error('Login failed');
    }
  };

  const logout = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_AUTHAPI}/logout`,
        {},
        { withCredentials: true }
      );
    } catch (error) {
      // Ignorar erros de logout para garantir limpeza local
    }
    setToken(null);
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    navigate('/'); // Redireciona para a página de login
  };

  const refreshToken = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_AUTHAPI}/refresh-token`, {
        refresh_token: localStorage.getItem('refreshToken'),
      });
      setToken(response.data.access_token);
      localStorage.setItem('accessToken', response.data.access_token);
      localStorage.setItem('refreshToken', response.data.refresh_token);
    } catch (error) {
      throw new Error('Token refresh failed');
    }
  };

  const isAuthenticated = async () => {
    if (!token) return false;
    try {
      const response = await axios.get(`${process.env.REACT_APP_AUTHAPI}/validate-token`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.status === 200;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        try {
          await refreshToken();
          return true;
        } catch (refreshError) {
          console.error('Token refresh failed:', refreshError);
          return false;
        }
      }
      console.error('Token validation failed:', error);
      return false;
    }
  };

  // Função para refresh automático, com debounce de 10s
  const refreshTokenDebounced = async () => {
    if (refreshTimeout.current) return;
    refreshTimeout.current = setTimeout(async () => {
      try {
        await refreshToken();
      } catch (e) {
        // Se falhar, faz logout
        await logout();
      }
      refreshTimeout.current = null;
    }, 10000); // 10 segundos entre refreshs automáticos
  };

  // IdleTimer callbacks
  const onIdle = async () => {
    // Usuário ficou inativo por mais de 30s, revoga o token
    await logout();
  };

  const onActive = async () => {
    // Usuário voltou a interagir, faz refresh do token
    if (token) {
      await refreshTokenDebounced();
    }
  };

  return (
    <IdleTimerProvider
      timeout={1000 * 300} // 30 segundos
      onIdle={onIdle}
      onActive={onActive}
      debounce={500}
      crossTab
    >
      <AuthContext.Provider value={{ token, login, logout, isAuthenticated, checkTokenAndRedirect }}>
        {userId && <EventListener userId={userId} />}
        {children}
      </AuthContext.Provider>
    </IdleTimerProvider>
  );
};

export const useAuth = () => useContext(AuthContext);